export const SystemIdentifier = 'sharefile';
export var RenderMode;
(function (RenderMode) {
    RenderMode[RenderMode["default"] = 0] = "default";
    RenderMode[RenderMode["specEdit"] = 1] = "specEdit";
})(RenderMode || (RenderMode = {}));
export var ResourceEntityType;
(function (ResourceEntityType) {
    ResourceEntityType["account"] = "account";
    ResourceEntityType["project"] = "project";
    ResourceEntityType["file"] = "file";
    ResourceEntityType["folder"] = "folder";
    ResourceEntityType["fileStream"] = "file_stream";
    ResourceEntityType["informationRequest"] = "inforeq";
})(ResourceEntityType || (ResourceEntityType = {}));
export var SortField;
(function (SortField) {
    SortField["ProjectName"] = "ProjectName";
    SortField["CreatedOn"] = "CreatedOn";
    SortField["UpdatedOn"] = "UpdatedOn";
})(SortField || (SortField = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
})(SortDirection || (SortDirection = {}));
export var ProjectUserRole;
(function (ProjectUserRole) {
    /** Externally referenced as Client */
    ProjectUserRole["Client"] = "Client";
    /** Externally referenced as Team member */
    ProjectUserRole["Counterpart"] = "Counterpart";
    ProjectUserRole["Owner"] = "Owner";
    /** Externally referenced as a Client (with sharing permissions) */
    ProjectUserRole["DelegatingClient"] = "DelegatingClient";
    /** User role with no permissions, not referenced externally */
    ProjectUserRole["Guest"] = "Guest";
})(ProjectUserRole || (ProjectUserRole = {}));
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["Open"] = "Open";
    ProjectStatus["Closed"] = "Closed";
})(ProjectStatus || (ProjectStatus = {}));
export var ProjectLifeCycleStage;
(function (ProjectLifeCycleStage) {
    ProjectLifeCycleStage["Active"] = "Active";
    ProjectLifeCycleStage["Deleted"] = "Deleted";
    ProjectLifeCycleStage["Frozen"] = "Frozen";
})(ProjectLifeCycleStage || (ProjectLifeCycleStage = {}));
export var DataVersion;
(function (DataVersion) {
    DataVersion[DataVersion["Original"] = 0] = "Original";
    DataVersion[DataVersion["RamEnabledForAuthorization"] = 1] = "RamEnabledForAuthorization";
})(DataVersion || (DataVersion = {}));
export var TagOperator;
(function (TagOperator) {
    TagOperator["ANY"] = "ANY";
    TagOperator["ALL"] = "ALL";
})(TagOperator || (TagOperator = {}));
//# sourceMappingURL=types.js.map